import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-none">
      <div className="max-w-7xl mx-auto px-6 h-24 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-4">
          <img src="/logo.png" alt="PacerApp Logo" className="h-12 w-auto object-contain" />
          <div className="flex flex-col">
            <span className="font-lexend font-bold text-xl leading-none tracking-tight">PacerApp</span>
            <span className="font-inter text-[10px] text-[#666] tracking-[0.15em] uppercase">Run Together, Progress Better.</span>
          </div>
        </Link>
        
        <div className="hidden lg:flex items-center gap-10 font-lexend font-bold text-[11px] tracking-[0.2em] text-[#888]">
          <a href="#benefits" className="hover:text-white transition-colors">BENEFICIOS</a>
          <a href="#tech" className="hover:text-white transition-colors">TECNOLOGÍA</a>
          <a href="#support" className="hover:text-white transition-colors">SUPPORT</a>
        </div>

        <button className="bg-pacer-gradient text-background font-lexend font-bold px-8 py-3 rounded-sm text-[11px] tracking-[0.2em] hover:shadow-[0_0_30px_rgba(114,220,255,0.3)] transition-all transform hover:scale-105 active:scale-95">
          CONECTAR CON STRAVA
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
